var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "h-100 d-flex flex-column" }, [
    _c("div", { staticClass: "sidebar-top" }, [
      _c(
        "div",
        { staticClass: "sidebar-item-no-border border-none" },
        [_c("mode-selector")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sidebar-item" },
        [
          _vm.creatorStudio.settings.activeTool === "similiarimage" &&
          _vm.creatorStudio.settings.similiarImageJob.apiJob === null
            ? _c("upload-box")
            : _vm._e(),
          _vm._v(" "),
          _vm.creatorStudio.settings.activeTool === "similiarimage" &&
          _vm.creatorStudio.settings.similiarImageJob.apiJob !== null
            ? _c("preview-similiar-image")
            : _vm._e(),
          _vm._v(" "),
          _vm.creatorStudio.settings.activeTool === "similiarimage"
            ? _c(
                "div",
                {
                  staticClass: "continue-btn",
                  on: { click: _vm.toggleFineTune },
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", [
                    _vm.fineTune === false
                      ? _c("i", { staticClass: "far fa-chevron-down" })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.fineTune === true
                      ? _c("i", { staticClass: "far fa-chevron-up" })
                      : _vm._e(),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.creatorStudio.settings.activeTool === "texttoimage" ||
          _vm.fineTune === true
            ? _c("prompt", { attrs: { isRowDynamic: true } })
            : _vm._e(),
          _vm._v(" "),
          _vm.creatorStudio.settings.activeTool === "texttoimage" ||
          _vm.fineTune === true
            ? _c(
                "div",
                { staticClass: "d-flex gap-10 justify-content-between" },
                [
                  _c("prompt-editor-nav-btn"),
                  _vm._v(" "),
                  _vm.creatorStudio.settings.activeTool === "texttoimage"
                    ? _c("surprise-me-button")
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-item" }, [_c("styles")], 1),
      _vm._v(" "),
      this.creatorStudio.settings.prompt_modifier.length > 0
        ? _c("div", { staticClass: "sidebar-item" }, [_c("prompt-modifier")], 1)
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-item" }, [_c("number-of-images")], 1),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-item" }, [_c("aspect-ratio")], 1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sidebar-item" },
        [_c("advanced-settings-btn")],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-item" }, [_c("credit-cost")], 1),
    ]),
    _vm._v(" "),
    !_vm.creatorStudio.isMobile
      ? _c(
          "div",
          { staticClass: "sidebar-bot btn-box" },
          [_c("generate-btn")],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "continue-btn-text" }, [
      _c("i", { staticClass: "far fa-cog" }),
      _vm._v("\n                    Fine-Tune Details\n                "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }